export default __webpack_public_path__ + "static/media/Snd1.2186ca84.mp3";